module.exports = __webpack_public_path__ + "img/banner_mobile_2.98013b13.jpeg";